import React from 'react';
import { Grid, Icon, Popup } from 'semantic-ui-react';
import classNames from 'classnames';
import POSButton from 'PointOfSale/modules/common/component/Button';
import 'PointOfSale/styles/components/popupMessage.less';

const PopupMessage = props => {
  const {
    item,
    position,
    messageText,
    onConfirmClick,
    togglePopup,
    openPopup,
  } = props;
  const displayClass = classNames(
    {
      hide: item.hide,
      'icon-buttons': true,
    },
    item.className
  );
  return (
    <Popup
      flowing
      position={position}
      trigger={
        <Icon
          link
          className={displayClass}
          name={item.icon}
          size={item.size}
          color={item.color}
        />
      }
      basic
      on="click"
      className="popup-message"
      open={openPopup}
      onClose={togglePopup}
      onOpen={() => {
        !item.disabled && togglePopup();
      }}
    >
      <span>{messageText}</span>
      <Grid columns="equal">
        <Grid.Column>
          <POSButton
            label="Yes"
            clickHandler={() => {
              togglePopup();
              if (onConfirmClick) onConfirmClick();
            }}
            variant="flat"
          />
        </Grid.Column>
        <Grid.Column>
          <POSButton label="No" clickHandler={togglePopup} variant="flat" />
        </Grid.Column>
      </Grid>
    </Popup>
  );
};

export default PopupMessage;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/component/PopupMessage.js